export default __webpack_public_path__ + "fonts/adu-calc-icon.svg";